import styled from "styled-components";

const Wrapper = styled.div`
  .selectBox {
    display: flex;
    margin: 10px 0px;
    height: 80px;
    flex-direction: column;
    position: relative;
  }
  .selectBox-Input {
    height: 38px;
    margin: 0 !important;
  }

  .selectBox .validation-message {
    margin-top: 5px;
  }
`;
export default Wrapper;